module.exports = __webpack_public_path__ + "media/images/svgs/jobs/medal-d23d17670ab0d7de0d46c980b497b1a6.svg";